<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>

                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success" @click="onClickEditUosd(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Elimina" variant="outline-danger" @click="onClickDeleteUosd(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <malattie-infettive-configurazione-uosd-modal-edit ref="cmpMalattieInfettiveConfigurazioneUosdModalEdit" @onSaveUosd="onSaveUosd" @deleteUosd="onUosdDelete" @onCloseModal="loadData" />
            <b-row class="sa-label-info">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import MalattieInfettiveConfigurazioneUosdModalEdit from "./MalattieInfettiveConfigurazioneUosdModalEdit.vue";

export default {
    components: { MalattieInfettiveConfigurazioneUosdModalEdit },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/malattieinfettiveuosd",
            listKey: 0,
            items: [],
            filtroConfigurazioneParametriVitali: {},
            fields: [
                { key: "index", label: "*", thStyle: "width: 5rem" },
                { key: "descrizione", label: "Descrizione" },
                { key: "actions", label: "", thStyle: "width: 10rem" },
            ],
        };
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },

    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResource, { forPage: me.perPage, page: me.currentPage }, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.error("Errore durante il caricamento dei dati di loadDataError:", error);
            me.items = [];
            me.rows = 0;
        },

        onClickEditUosd(item) {
            let me = this;
            me.$refs.cmpMalattieInfettiveConfigurazioneUosdModalEdit.setId(item.id);
        },
        onClickNuovoUosd() {
            let me = this;
            me.$refs.cmpMalattieInfettiveConfigurazioneUosdModalEdit.setId(null);
        },
        onClickDeleteUosd(item) {
            let me = this;
            me.$refs.cmpMalattieInfettiveConfigurazioneUosdModalEdit.onDeleteUosd(item);
        },
        onSaveUosd() {
            let me = this;
            console.log("onUosdSave");
            me.loadData();
        },
        onUosdDelete() {
            let me = this;
            me.loadData();
        },
        onCloseModalParametroVitale() {
            let me = this;
            me.loadData();
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
